var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-capsule",
    { attrs: { formTitle: _vm.$t("suppliers.form_supplier_create_title") } },
    [
      _c("template", { slot: "formcontent" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("form-write-group-label-input", {
              attrs: {
                isMandatory: true,
                inputLabel: _vm.$t("suppliers.supplier_id"),
                placeholderValue: _vm.$t("suppliers.supplier_id"),
                mandatoryErrorIndicator: _vm.sirenError,
                regexpErrorIndicator: _vm.sirenRegexpError,
              },
              model: {
                value: _vm.siren,
                callback: function ($$v) {
                  _vm.siren = $$v
                },
                expression: "siren",
              },
            }),
            _vm._v(" "),
            _c("form-write-group-label-input", {
              attrs: {
                disabled: true,
                inputLabel: _vm.$t("filter.supplier_id"),
                placeholderValue: _vm.$t("filter.supplier_id"),
                mandatoryErrorIndicator: _vm.sellerIdentifierError,
                isMandatory: "",
              },
              model: {
                value: _vm.sellerIdentifier,
                callback: function ($$v) {
                  _vm.sellerIdentifier = $$v
                },
                expression: "sellerIdentifier",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("form-write-group-label-input", {
              attrs: {
                isMandatory: true,
                inputLabel: _vm.$t("common.social_reason"),
                placeholderValue: _vm.$t("common.social_reason"),
                mandatoryErrorIndicator: _vm.socialReasonError,
              },
              model: {
                value: _vm.socialReason,
                callback: function ($$v) {
                  _vm.socialReason = $$v
                },
                expression: "socialReason",
              },
            }),
            _vm._v(" "),
            _c("form-write-group-label-input", {
              attrs: {
                inputLabel: _vm.$t("suppliers.supplier_name"),
                placeholderValue: _vm.$t("suppliers.supplier_name"),
              },
              model: {
                value: _vm.name,
                callback: function ($$v) {
                  _vm.name = $$v
                },
                expression: "name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("form-write-group-label-input", {
              attrs: {
                inputLabel: _vm.$t("common.eml_adrs"),
                placeholderValue: _vm.$t("common.eml_adrs"),
                regexpErrorIndicator: _vm.emailAddressRegexpError,
              },
              model: {
                value: _vm.emailAddress,
                callback: function ($$v) {
                  _vm.emailAddress = $$v
                },
                expression: "emailAddress",
              },
            }),
            _vm._v(" "),
            _c("form-write-group-label-input", {
              attrs: {
                inputLabel: _vm.$t("common.street_name"),
                placeholderValue: _vm.$t("common.street_name_example"),
              },
              model: {
                value: _vm.streetName,
                callback: function ($$v) {
                  _vm.streetName = $$v
                },
                expression: "streetName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("form-write-group-label-input", {
              attrs: {
                inputLabel: _vm.$t("common.zp_code"),
                placeholderValue: _vm.$t("common.zp_code"),
              },
              model: {
                value: _vm.zipCode,
                callback: function ($$v) {
                  _vm.zipCode = $$v
                },
                expression: "zipCode",
              },
            }),
            _vm._v(" "),
            _c("form-write-group-label-input", {
              attrs: {
                inputLabel: _vm.$t("common.cty"),
                placeholderValue: _vm.$t("common.cty"),
              },
              model: {
                value: _vm.townName,
                callback: function ($$v) {
                  _vm.townName = $$v
                },
                expression: "townName",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("template", { slot: "footerbuttons" }, [
        _c("div", { staticClass: "row justify-content-start" }, [
          _c("div", { staticClass: "col-md-3 offset-md-8" }, [
            _c(
              "button",
              {
                staticClass:
                  "button-action firstButtonMarginTop col-md milkyBlockBlack",
                attrs: { round: "" },
                on: { click: _vm.updateSupplier },
              },
              [
                _c("i", { staticClass: "icon fa fa-save" }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("suppliers.form_supplier_edit_button")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }